import { render } from "./indexsixoffer.vue?vue&type=template&id=2c9a2d09"
import script from "./indexsixoffer.vue?vue&type=script&lang=js"
export * from "./indexsixoffer.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__